<div class="form u-mb50">
  <label for="" class="label">
    {{title}}
  </label>
  <textarea *ngIf="!whitePanel"  [placeholder]="placeholder" [formControl]="controlForm" [maxlength]="maxlength"></textarea>
  <textarea *ngIf="whitePanel" class="form--white" [placeholder]="placeholder" [formControl]="controlForm" [maxlength]="maxlength"></textarea>
  <small class="character-counter"
    [ngClass]="currentValue.length === maxlength ? 'text-red' : ''">{{currentValue.length}}/{{maxlength}}
    caracteres</small>
</div>
